import DashboardMain from "components/Dashboard/index.jsx";
import ReportModule from "../components/Reports";
import AssetTest from "../components/AssetTests/AssetTests";
import JourneyPlan from "components/JourneyPlan/index";
import Track from "components/Track/index";

import MaintenanceWorkOrder from "../components/MaintenanceWorkOrder";

import MaintenanceBacklog from "components/Maintenance/index";
import MaintenanceDetail from "components/Maintenance/MaintenanceDetail/index";
import MaintenanceDetailV2 from "components/Maintenance/MaintenanceDetailPage/MaintenanceDetailPage";
import WorkOrders from "components/WorkOrders/index";
import IssuesReports from "components/IssuesReports/index";
import IssueDetail from "components/IssuesReports/IssueDetail/index";

import TrackDetail from "components/Track/TrackDetail/index";
import JourneyPlanDetail from "components/JourneyPlan/JourneyPlanDetail/index";

import WOGISView from "components/WorkOrders/WOGISView";
import TrackChart from "components/TrackChart/index";

//TODO will be removed when YardReport is completed
import YardReport from "components/Reports/Timps/Yard/yardReport.jsx";
import TestForms from "../components/diagnostics/TestForms";

import InsulationResistance from "components/Reports/sims/insulationResistance.jsx";
import RelayTest from "components/Reports/sims/relayTest.jsx";
import HighWayCrossing from "../components/Reports/sims/highWayCrossingCombined/highWayCrossing";
import AppReport from "../components/AppReports/appReport";
import { AppReportBriefings } from "../components/AppReports/appReport";

import ATIVData from "components/ATIV/index";
// import Board from "../wigets/Board/index.jsx"
import InspectionPlanDashboard from "../components/InspectionPlanDashboard/InspectionPlanDashboard";
import Safetybriefiing from "../components/jobBriefing/SafetyBreifing/SafetyBriefiing";
import { HoursofServiceContainerMobileAppView } from "../components/HoursOfService";
import Maintenancedetailpage from "../components/Maintenance/MaintenanceDetailPage/MaintenanceDetailPage";
import SimulatorContainer from "../components/Simulator/Simulator";
// import DetailedTurnoutReport from "../components/Reports/Timps/EtrSwitchReport/detailedTurnoutInspectionReportView.jsx"
// import CrossingWarning from "../components/Reports/sims/ontario/crossingWarning.jsx"
// import SignalStorageBattery from "../components/Reports/sims/ontario/signalStorageBattery.jsx"
import PullLIstSimulatorContainer from "../components/diagnostics/PullListSimulator/PullListSimulator";
import Sampletestreport from "../components/Reports/SampleReport/SampleTestReport";
import ReportSummaryContainer from "../components/ReportSummary";
import DbanalysismoduleContainer from "../components/diagnostics/dbAnalysisModule/dbAnalysisModule";
import PIScheduler from "../components/PiScheduler";
import CombineReportsContainer from "../components/Reports/CombineReports";
import AppSessionExpired from "../components/AppSessionExipre";
import SiteWorkOrderReports from "../components/Reports/SITEWorkOrderReports";
import InspectionScheduleContainer from "../components/InspectionSchedule";
export const timpsRoutes = [
  { path: "/inspection", component: JourneyPlan },
  { path: "/inspections/:id", component: JourneyPlanDetail },
  { path: "/issueDetails", component: IssueDetail },
  { path: "/issuereports", component: IssuesReports },
  { path: "/track", component: Track },
  { path: "/tracks/:id", component: TrackDetail },
  { path: "/maintenance", component: MaintenanceWorkOrder },
  { path: "/maintenancebacklog", component: MaintenanceBacklog },
  { path: "/maintenancebacklogs/:id", component: MaintenanceDetailV2 },
  { path: "/maintenancebacklogsold/:id", component: MaintenanceDetail },

  { path: "/workorders", component: WorkOrders },
  { path: "/workorderGISView/:id", component: WOGISView },
  { path: "/trackChart", component: TrackChart },
  { path: "/reports", component: ReportModule },
  { path: "/CombineReports", component: CombineReportsContainer },
  { path: "/inspectionplantests", component: InspectionPlanDashboard },
  { path: "/assetTest", component: AssetTest },
  //TODO will be removed when YardReport is completed
  { path: "/yardReport", component: YardReport },
  { path: "/appForms", component: TestForms },
  { path: "/insulationResistance", component: InsulationResistance },
  { path: "/relayTest", component: RelayTest },
  { path: "/highWayCrossing", component: HighWayCrossing },
  { path: "/appReport", component: AppReport },
  { path: "/appReportBriefings", component: AppReportBriefings },
  { path: "/ativ-data", component: ATIVData },
  { path: "/jobBriefing", component: Safetybriefiing },
  { path: "/SiteWorkOrderReports", component: SiteWorkOrderReports },
  { path: "/appHos", component: HoursofServiceContainerMobileAppView },
  { path: "/list", component: PullLIstSimulatorContainer },
  { path: "/simulator", component: SimulatorContainer },
  { path: "/sampleReports", component: Sampletestreport },
  { path: "/reportSummary", component: ReportSummaryContainer },
  { path: "/dbanalysis", component: DbanalysismoduleContainer },
  { path: "/PIScheduler", component: PIScheduler },
  { path: "/InspectionSchedule", component: InspectionScheduleContainer },
  { path: "/appSessionExpire", component: AppSessionExpired },

  // { path: "/board", component: Board },
  // { path: "/detailedTurnout", component: DetailedTurnoutReport },
  // { path: "/crossingWarning", component: CrossingWarning },
  // { path: "/signalStorageBattery", component: SignalStorageBattery }
];



// WEBPACK FOOTER //
// ./src/routes/timps.routes.js